var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          icon: 'tim-icons icon-chart-pie-36',
          path: {name: 'auditor.dashboard'},
        }}}),_c('sidebar-item',{attrs:{"material":true,"link":{
          name: _vm.$t('sidebar.users'),
          icon: 'group',
          path: {name: 'auditor.user'},
          isRoute: false,
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.purchase_order'),
          icon: 'tim-icons icon-cart',
        }}},[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.charts'),
          path: {name: 'auditor.purchase_order_board'}
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.add'),
          icon: 'tim-icons icon-cart',
          path: {name: 'auditor.purchase_order_create'}

        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.purchase_order'),
          icon: 'tim-icons icon-cart',
          path: {name: 'auditor.purchase_order'}

        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.import'),
          icon: 'tim-icons icon-cloud-upload-94',
          path: {name: 'auditor.imports'}
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.exports'),
          icon: 'tim-icons icon-notes',
          path: {name: 'auditor.purchase_order_exports'}
        }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }